import React, { Fragment, JSX, useEffect, useState } from "react";
import { IWorksheet } from "../../../model/interface/worksheet";
import Loader from "../../shared/loader/loader";
import { DownloadIcon } from "../../../assets/icons/index";

interface WorksheetProps {
  worksheetData: IWorksheet;
  previewData?: {
    title?: string;
    previewType?: string;
  };
  downloadWS?: any;
  filePath?: string;
  worksheetId?: number;
}

function WorksheetFilePreview(props: WorksheetProps): JSX.Element {
  const [worksheetURL, setWorksheetURL] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const getWorksheetPreview = async () => {
    const fileURL =
      props?.previewData?.previewType == "file"
        ? props?.worksheetData?.worksheetFilePath
        : props?.worksheetData?.worksheetKeyFilePath;
    if (fileURL) {
      const service = await import("../../../api/worksheets.service");
      service
        .getWorksheetPreviewURL(props?.worksheetData?.worksheetId, fileURL)
        .then((res) => {
          setLoading(true);
          setWorksheetURL(res.data);
        });
    }
  };
  useEffect(() => {
    getWorksheetPreview();
  }, [props?.worksheetData?.worksheetId]);

  return (
    <Fragment>
      {loading && <Loader />}
      <div className="text-gray-900 block px-4 py-4 text-sm shadow border-b border-gray-200 rounded-b-lg h-full">
        <div className="relative flex">
          <div className="w-full mt-4 mb-4 flex justify-between">
            {props?.previewData?.title}
            {props?.filePath && (
              <div className="flex relative cursor-pointer rounded-lg font-medium">
                <DownloadIcon className="w-4 text-gray-500 group-hover:text-blue-500 mr-1"></DownloadIcon>

                <span className="text-blue-700 group-hover:text-blue-500">
                  <a href={worksheetURL} target={"_blank"} rel="noreferrer">
                    {props?.filePath}
                  </a>
                </span>
              </div>
            )}
          </div>
        </div>
        {worksheetURL && (
          <iframe
            src={worksheetURL}
            title={props?.worksheetData?.title}
            style={{ width: "100%", height: "100%" }}
            onLoad={() => setLoading(false)}
          ></iframe>
        )}
      </div>
    </Fragment>
  );
}

export default WorksheetFilePreview;
